import '../LoggedOut/PrivatePolicy/PrivatePolicy.css';
import React, { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { navigationBarState } from '../../states/NavigationBar';

function TestTerms() {
    const setNavigationBarState = useSetRecoilState(navigationBarState);

    useEffect(() => {
        setNavigationBarState({
            title: '시험 응시 및 결제 약관',
            'left-item': { type: 'back' },
        });
    }, [setNavigationBarState]);

    return (
        <div className="privacy-page">
            <div className="privacy-container">
                <div className="privacy-header">
                    <h1 className="privacy-title">시험 응시 및 결제 약관</h1>
                    <p className="privacy-subtitle">주식회사 케이비티영어교육 시험 서비스 이용약관</p>
                </div>

                <div className="privacy-content">
                    <div className="privacy-intro">
                        본 약관은 주식회사 케이비티영어교육(이하 "회사")가 제공하는 시험 서비스의 이용 조건 및
                        결제에 관한 사항을 규정합니다.
                    </div>

                    {/* Section 1 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">1</span>
                            시험 응시 규정
                        </div>
                        <div className="privacy-section-text">
                            <p>
                                (약관 내용 준비 중)
                            </p>
                        </div>
                    </div>

                    {/* Section 2 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">2</span>
                            결제 및 환불 정책
                        </div>
                        <div className="privacy-section-text">
                            <p>
                                (약관 내용 준비 중)
                            </p>
                        </div>
                    </div>

                    {/* Section 3 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">3</span>
                            인증서 발급 기준
                        </div>
                        <div className="privacy-section-text">
                            <p>
                                (약관 내용 준비 중)
                            </p>
                        </div>
                    </div>

                    {/* Section 4 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">4</span>
                            부정행위 및 제재
                        </div>
                        <div className="privacy-section-text">
                            <p>
                                (약관 내용 준비 중)
                            </p>
                        </div>
                    </div>

                    {/* Section 5 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">5</span>
                            면책 조항
                        </div>
                        <div className="privacy-section-text">
                            <p>
                                (약관 내용 준비 중)
                            </p>
                        </div>
                    </div>

                    <div className="privacy-footer">
                        <div className="privacy-effective-date">
                            <strong>시행일자: 2025년 11월 30일</strong>
                            <br />
                            이 약관은 2025년 11월 30일부터 시행합니다.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TestTerms;
